module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-fdb64026.png";